import React, { useEffect, useRef, useState } from "react";

interface SectionProps extends React.HTMLAttributes<HTMLDivElement> {
  backgroundImage: string;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({
  backgroundImage,
  children,
  ...props
}) => {
  return (
    <div
      className={`relative spacer ${props.className}`}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        ...props.style,
      }}
      {...props}
    >
      <div className="container mx-auto px-7 py-10 relative z-10">
        {children}
      </div>
    </div>
  );
};

export default Section;
